import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function Support() {
  const { language } = useLanguage();

  const supportBody =
    language === "fr"
      ? "Veuillez%20préciser%20le%20nom%20de%20l'application%20et%20décrire%20votre%20problème%20ou%20question%20ici."
      : "Please%20specify%20the%20app%20name%20and%20describe%20your%20issue%20or%20question%20here.";

  const supportSubject =
    language === "fr" ? "Demande%20de%20Support" : "Support%20Request";

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container support-page">
          <div className="section-header">
            <span className="section-badge">{translate("support", language)}</span>
            <h1 className="section-title">{translate("supportTitle", language)}</h1>
            <p className="section-description">
              {translate("supportIntro", language)}
            </p>
          </div>

          <div className="support-content">
            <p className="support-email-wrap">
              <a
                href={`mailto:support@ygalaad.com?subject=${supportSubject}&body=${supportBody}`}
                className="support-link"
              >
                support@ygalaad.com
              </a>
            </p>
            <p className="section-description support-response">
              {translate("supportResponse", language)}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Support;
